import { NavigationTree, NavigationTreeLeaf } from './navigation';

export function isNavigationLeafNode(node: NavigationTree[number]): node is NavigationTreeLeaf {
	return !!(node as any)['link'];
}
